import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import {
  API_QUERY_KEYS,
  getConsultations,
  GetConsultationsResponse,
  QueryDefaults,
} from 'api';
import { searchPageNumberState, searchRequestState } from 'store';

export const useConsultations = (): UseQueryResult<GetConsultationsResponse> => {
  const request = useRecoilValue(searchRequestState);
  const setPageNumber = useSetRecoilState(searchPageNumberState);
  return useQuery(
    [API_QUERY_KEYS.getConsultations, request],
    () => getConsultations(request),
    {
      ...QueryDefaults,
      onSuccess: (data: GetConsultationsResponse) => {
        if (data?.paginationInfo?.totalCount > 0 && data?.consultations.items.length === 0) {
          setPageNumber(1);
        }
      },
    }
  );
};
